module.exports = __webpack_public_path__ + "static/media/sharepointMobile.efc51d70.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/sharepointMobile.jpg
// module id = 879
// module chunks = 15